export const deleteInputValue = (eId: string) => {
  //@ts-ignore
  document.getElementById(eId).value = ''
}

export const dishplaceholder = require('../assets/img/dishplaceholder.svg')?.default

export function formatCurrency(currency: number): string {
  return (currency?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') ?? '0') + 'đ'
}